export default __webpack_public_path__ + "static/media/GooglePlayBadgeWhite.23a518a0.svg";